<template>
  <div id="app">
    <Header></Header>
    <div class="main-container">
      <img class="header-bg" src="../assets/img/banner6.jpg" alt="" />
      <div class="navi-container">
        <div class="navi-list">
          <div class="navi-item active">
            <a href="hdsq.html">活动专区</a>
          </div>
          <div class="navi-item">
            <a href="wdsq.html">问答专区</a>
          </div>
        </div>
      </div>

      <div class="articleList-container">
        <div class="articleList-content">
          <div class="articleList">
            <Card :list="cardList" v-if="!!cardList" :type="cardType"></Card>
            <div
              style="
                margin: 24px 0 40px;
                display: flex;
                justify-content: center;
              "
            >
              <Pagination
                :totalpage="totalpage"
                @pageChange="pageChange"
              ></Pagination>
            </div>
          </div>

          <!-- <div class="likeList">
            <Like :list="cardList"></Like>
          </div> -->
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import Pagination from "../components/pagination.vue";
import Card from "../components/cardList.vue";
// import Like from "../components/likeList.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    Pagination,
    Card,
    // Like,
  },
  data: () => {
    return {
      totalpage: 1,
      currentpage: 1,

      cardType: "1", //0 农技文章,1活动卡片
      cardList: [],
    };
  },
  beforeMount() {
    function getUrlString() {
      var urlStr = window.location.search; //?sex=man&age=20
      console.log(urlStr);
      if (urlStr != null && urlStr.toString().length > 1) {
        var myUrlStr = urlStr.substr(1); //sex=man&age=20
        var array1 = myUrlStr.split("&"); //["sex=man"],["age=20"]
        var getString = {};
        for (var i = 0; i < array1.length; i++) {
          getString[array1[i].split("=")[0]] = array1[i].split("=")[1]; //["sex","man"]["age","20"]
        }
        return getString;
      } else {
        console.log("无参数");
      }
    }
    var gus = new getUrlString();
    console.log(gus);

    this.$axios
      .get(
        `https://m.nongjike.cn/smallNjk/small/showResearchOrLiveList?pageNum=1&pageSize=5`
      )
      .then((res) => {
        console.log(res);
        let list = res.data.information.list;
        this.cardList = list.map((v) => {
          return {
            title: v.subject,
            desc: v.htmlContent.replace(/&nbsp;/g, ""),
            author: "每天农资",
            time: v.createTime,
            clickViews: v.clickViews,
            imgUrl: v.img,
            link: `hdsqxq.html?id=${v.id}`,
          };
        });
        this.totalpage = res.data.information.total;
      });
  },
  methods: {
    pageChange(n) {
      console.log(n);
      this.$axios
        .get(
          `https://m.nongjike.cn/smallNjk/small/showResearchOrLiveList?pageNum=${n}&pageSize=5`
        )
        .then((res) => {
          console.log(res);
          let list = res.data.information.list;
          this.cardList = list.map((v) => {
            return {
              title: v.subject,
              desc: v.htmlContent.replace(/&nbsp;/g, ""),
              author: "每天农资",
              time: v.createTime,
              clickViews: v.clickViews,
              imgUrl: v.img,
              link: `hdsqxq.html?id=${v.id}`,
            };
          });
          this.totalpage = res.data.information.total;
        });
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 121px;
}
a {
  & > * {
    text-decoration: none;
  }
  text-decoration: none;
}

.image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  img {
    width: 50%;
    height: auto;
    display: block;
  }
}

.main-container {
  width: 100%;
  .header-bg {
    width: 100%;
    display: block;
  }
}
.crop-selector-container {
  width: 100%;
  background: #f5f5f5;
  padding: 40px 0 24px;
  .crop-selector {
    width: 1200px;
    margin: 0 auto;

    .crop-item {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      &:last-child {
        margin-bottom: 0;
      }
      .crop-group {
        font-size: 16px;
        width: 80px;
        color: #333;
        text-align: left;
        margin-right: 10px;
        line-height: 20px;
      }
      .crop-titles {
        color: #999;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        line-height: 24px;

        a {
          border: 1px solid #999;
          color: #999;
          display: block;
          font-size: 14px;
          width: 136px;
          height: 36px;
          padding: 0 8px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-right: 16px;
          text-align: center;
          line-height: 34px;
          margin-bottom: 16px;
          &:hover {
            color: #fff;
            border-color: #65b825;
            background: #65b825;
          }
          &:nth-of-type(8n) {
            margin-right: 0;
          }
        }
      }
    }
  }
}
.articleList-container {
  width: 100%;
  background: #fff;
  .articleList-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 30px;
    .articleList {
      width: 100px;
      flex-grow: 1;
      //   margin-right: 54px;
    }

    .likeList {
      width: 360px;
    }
  }
}
.navi-container {
  width: 100%;
  height: 64px;
  background: #65b825;
  .navi-list {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #65b825;
    .navi-item {
      width: 600px;
      flex-grow: 1;
      background: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 62px;
      position: relative;
      left: -1px;
      a {
        display: block;
        width: 100%;
        height: 32px;
        line-height: 32px;
        font-size: 22px;
        color: #fff;
        border-right: 2px solid #fff;
        text-align: center;
      }
      &:last-child a {
        border-color: transparent;
      }
      &:hover {
        background: #fff;
        margin-left: -2px;
        margin-right: 2px;
        a {
          color: #65b825;
          border-right: transparent;
        }
      }
      &.active {
        background: #fff;
        margin-left: -2px;
        margin-right: 2px;
        a {
          color: #65b825;
          border-right: transparent;
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  #app {
    margin-top: 91px;
  }
  .login_container {
    padding-left: 10px;
  }
  .headers {
    width: 100%;
    padding-left: 10px;
  }
  #app {
    overflow: hidden;
  }
  #app .headers .header-nav {
    display: none;
  }
  .navi-container {
    height: 37px;
    .navi-list {
      width: 100%;
      .navi-item {
        height: 36px;
        a {
          font-size: 14px;
        }
      }
    }
  }
  .articleList-container .articleList-content {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    .articleList {
      margin-right: 0;
    }
    .shop-list {
      justify-content: space-around;
      .shop-item {
        width: 40vw;
        margin-right: 0;
        height: 40vw;
        .shop-image {
          width: 40vw;
          height: 40vw;
          .el-image {
            width: 40vw;
            height: 40vw;
          }
        }
        .shop-info {
          width: 40vw;
          height: 30px;
          .shop-title {
            font-size: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 0 10px;
          }
          .shop-more {
            top: 12px;
            img {
              width: 10px;
              height: 6px;
            }
          }
        }
      }
    }
  }
}
</style>
